import React from 'react'
import tw from 'tailwind-styled-components'
import {
  IconTabler,
  TablerIcons
} from '@components/common/icon-tabler/icon-tabler'
import {cn} from '@containers/html-utils'
import {TwIconLeft, TwIconRight, TwWrap} from '../containers'
import {ButtonProps, TwProps} from '../types'
import {
  getDefault,
  getDisabled,
  getHover,
  getPressed,
  getSize,
  getSvgSize
} from './link-button-utils'

const TwLinkButton = tw.div<TwProps>`
  flex
  w-fit
  cursor-pointer
  select-none
  flex-shrink-0

   ${p => {
     if (p.$forcedState === 'active') {
       return 'text-action-pressed'
     } else if (p.$forcedState === 'hover') {
       return 'text-action-default'
     } else if (p.$forcedState === 'default') {
       return 'text-secondary'
     }
     return ''
   }}

  ${p => (p.$disabled ? getDisabled(p.$color) : getDefault(p.$color))}
  ${p => getSize(p.$size, p.$noPaddings)}
  ${p => getHover(p.$color)}
  ${p => getPressed(p.$color)}
  ${p => (p.$truncate ? 'truncate' : '')}
`

export const LinkButton = React.forwardRef(
  (
    {
      disabled = false,
      color = 'primary',
      size = 'medium',
      iconPosition = 'left',
      icon,
      children,
      noPaddings = false,
      iconPadding = '8',
      truncate = true,
      forcedState,
      ...props
    }: ButtonProps,
    ref
  ) => {
    const leftPosition = iconPosition === 'left' || iconPosition === 'both'
    const rightPosition = iconPosition === 'right' || iconPosition === 'both'
    const svgSize = getSvgSize(size)
    const iconTablerViewBox = '0 0 24 24'

    return (
      <TwLinkButton
        ref={ref}
        $size={size}
        $color={color}
        $disabled={disabled}
        $noPaddings={noPaddings}
        $truncate={truncate}
        $forcedState={forcedState}
        {...props}
      >
        <TwWrap $truncate={truncate}>
          {icon && leftPosition && (
            <TwIconLeft $paddingRight={iconPadding}>
              {typeof icon === 'object' ? (
                icon
              ) : (
                <IconTabler
                  customSize={svgSize}
                  icon={icon as TablerIcons}
                  viewBox={iconTablerViewBox}
                />
              )}
            </TwIconLeft>
          )}
          <span className={cn(truncate && 'truncate')}>{children}</span>
          {icon && rightPosition && (
            <TwIconRight>
              {typeof icon === 'object' ? (
                icon
              ) : (
                <IconTabler
                  customSize={svgSize}
                  icon={icon as TablerIcons}
                  viewBox={iconTablerViewBox}
                />
              )}
            </TwIconRight>
          )}
        </TwWrap>
      </TwLinkButton>
    )
  }
)
